document.querySelectorAll(".disclosure").forEach((details) => {
  const summary = details.querySelector("summary");
  const cancel = details.querySelector('button[type="reset"]');

  summary.setAttribute(
    "aria-expanded",
    summary.parentElement.hasAttribute("open")
  );

  summary.addEventListener("click", () => {
    summary.setAttribute("aria-expanded", !details.hasAttribute("open"));
  });

  cancel &&
    cancel.addEventListener("click", () => {
      details.removeAttribute("open");
      summary.setAttribute("aria-expanded", "false");
    });
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function pauseAllMedia() {
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

// Define a global DrawerMenu object
window.DrawerMenu = (function () {
  // Private variables and functions
  let drawer, toggle, content, close, overlay;

  // Initialize the drawer
  function init(selector = ".drawer-menu") {
    drawer = document.querySelector(selector);
    if (!drawer) return;

    toggle = drawer.querySelector(".drawer-menu__toggle");
    content = drawer.querySelector(".drawer-menu__content");
    close = drawer.querySelector(".drawer-menu__close");
    overlay = drawer.querySelector(".drawer-menu__overlay");

    if (!toggle || !content || !close || !overlay) {
      console.warn("DrawerMenu: Required elements not found");
      return;
    }

    setupEventListeners();
  }

  // Toggle drawer state
  function toggleDrawer() {
    const isOpen = content.classList.toggle("active");
    overlay.classList.toggle("active");
    toggle.setAttribute("aria-expanded", isOpen);
    document.body.style.overflow = isOpen ? "hidden" : "";
  }

  // Setup all event listeners
  function setupEventListeners() {
    // Main toggle events
    toggle.addEventListener("click", toggleDrawer);
    close.addEventListener("click", toggleDrawer);
    overlay.addEventListener("click", toggleDrawer);

    // ESC key handler
    document.addEventListener("keydown", handleEscKey);

    // Prevent clicks inside drawer from closing it
    content.addEventListener("click", (e) => e.stopPropagation());

    // Accordion behavior
    setupAccordion();
  }

  // Handle ESC key
  function handleEscKey(e) {
    if (e.key === "Escape" && content.classList.contains("active")) {
      toggleDrawer();
    }
  }

  // Setup accordion functionality
  function setupAccordion() {
    const accordions = drawer.querySelectorAll(".drawer-menu__accordion");
    accordions.forEach((accordion) => {
      accordion.addEventListener("toggle", (e) => {
        if (e.target.open) {
          const siblings =
            e.target.parentElement.parentElement.querySelectorAll(
              ".drawer-menu__accordion"
            );
          siblings.forEach((sibling) => {
            if (sibling !== e.target) {
              sibling.removeAttribute("open");
            }
          });
        }
      });
    });
  }

  // Public API
  return {
    // Initialize the drawer with an optional custom selector
    init: function (selector) {
      init(selector);
    },

    // Manually toggle the drawer
    toggle: function () {
      if (content) toggleDrawer();
    },

    // Open the drawer
    open: function () {
      if (content && !content.classList.contains("active")) {
        toggleDrawer();
      }
    },

    // Close the drawer
    close: function () {
      if (content && content.classList.contains("active")) {
        toggleDrawer();
      }
    },

    // Check if drawer is open
    isOpen: function () {
      return content ? content.classList.contains("active") : false;
    },
  };
})();

// Auto-initialize when DOM is loaded if not already initialized
document.addEventListener("DOMContentLoaded", () => {
  if (!window.DrawerMenu.initialized) {
    window.DrawerMenu.init();
    window.DrawerMenu.initialized = true;
  }
});
